import {
  IMAGE_FILE_TYPES,
  PRODUCTS_BINDING_INPUT,
} from "@/libs/builder/consts";

export const navLink = [
  {
    name: "title",
    type: "string",
    required: true,
  },
  {
    name: "url",
    type: "url",
    required: true,
  },
  {
    name: "secondaryNavigation",
    type: "reference",
    model: "secondary-navigation",
  },
  {
    name: "isLoyalty",
    type: "boolean",
  },
  {
    name: "loyaltyPointsCurrency",
    helperText: "Label for loyalty points currency",
    showIf: 'options.get("isLoyalty") === true',
    type: "string",
  },
] as const satisfies Inputs;

export const headerInputs = [
  {
    name: "logo",
    type: "object",
    defaultValue: {
      link: "/",
      srcDark: "",
      srcLight: "",
      title: "",
      alt: "Logo",
    },
    required: true,
    subFields: [
      {
        name: "link",
        type: "url",
        required: true,
      },
      {
        name: "srcDark",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "srcLight",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
    ],
  },
  {
    name: "navLinks",
    type: "list",
    defaultValue: [
      {
        title: "Home",
        url: "/",
      },
      {
        title: "About",
        url: "/about",
      },
      {
        title: "Shop",
        url: "/",
      },
      {
        title: "Ploom Club",
        url: "/loyalty",
        isLoyalty: true,
      },
    ],
    subFields: navLink,
  },
  {
    name: "accountDropdownSettings",
    type: "object",
    defaultValue: {
      logoutRedirectPage: "/",
      logoutLabel: "Sign out",
      greetingMessage: "Hi,",
      hideGreetingMessage: false,
      profileLink: "/profile",
      accountDashboardLabel: "Account Dashboard",
      ordersLabel: "My orders",
      paymentsLabel: "My payment methods",
      accountInformationLabel: "Account information",
      packCodesLink: "/pack-codes",
      packCodesLabel: "Pack codes",
    },
    subFields: [
      {
        name: "logoutRedirectPage",
        type: "url",
        required: true,
      },
      {
        name: "logoutLabel",
        type: "string",
        required: true,
      },
      {
        name: "greetingMessage",
        type: "string",
      },
      {
        name: "hideGreetingMessage",
        type: "boolean",
      },
      {
        name: "profileLink",
        type: "url",
      },
      {
        name: "accountDashboardLabel",
        type: "string",
      },
      {
        name: "ordersLabel",
        type: "string",
      },
      {
        name: "paymentsLabel",
        type: "string",
      },
      {
        name: "accountInformationLabel",
        type: "string",
      },
      {
        name: "packCodesLink",
        type: "url",
      },
      {
        name: "packCodesLabel",
        type: "string",
      },
    ],
  },
  {
    name: "tools",
    type: "object",
    defaultValue: {
      accountLink: "/",
      cartLink: "/",
      storeLocatorLink: "/",
      mobileAppLink: "/",
      resultsLink: "/",
    },
    required: true,
    subFields: [
      {
        name: "accountLink",
        type: "url",
      },
      {
        name: "storeLocatorLink",
        type: "url",
      },
      {
        name: "mobileAppLink",
        type: "url",
      },
      {
        name: "resultsLink",
        type: "url",
      },
    ],
  },
  PRODUCTS_BINDING_INPUT,
] as const satisfies Inputs;

export type HeaderProps = BuilderComponentProps<typeof headerInputs>;
